<small class="debug">{{me}}</small>
<app-button-bar [items]="highlightedRows" [setButtons]="buttons" (buttonEmit)="$event.name === 'add' ? onAdd($event) : onRemove($event)"></app-button-bar>
<table mat-table multiTemplateDataRows [dataSource]="dataSource" class="mat-elevation-z8 matTableMaxSpace">
  <ng-container matColumnDef="eventName">
    <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>{{'general.event' | transloco}} </th>
    <td mat-cell class="textAlignLeft" *matCellDef="let element; let index = index">
      {{element.eventName | PipeTruncate:['10']}}
    </td>
  </ng-container>
  <ng-container matColumnDef="condition">
    <th mat-header-cell *matHeaderCellDef>{{'general.condition' | transloco}}</th>
    <td mat-cell *matCellDef="let element">
      {{element.condition}}
    </td>
  </ng-container>
  <ng-container matColumnDef="field">
    <th mat-header-cell *matHeaderCellDef>{{'general.field' | transloco}} </th>
    <td mat-cell class="textAlignLeft" *matCellDef="let element; let index = index">
      {{element.field | PipeTruncate:['10']}}
    </td>
  </ng-container>

  <ng-container matColumnDef="editIcon">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element; let index = dataIndex">
      @if (expandedElement != element) {
        <span class="drgIcon" (click)="expandEditor(element, index)">
          <mat-icon matTooltip="{{'general.edit' | transloco}}"
            [ngStyle]="{'color': 'var(--background-green)'}">
            edit
          </mat-icon>
        </span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="expandedPanel">
    <td mat-cell *matCellDef="let element; let index = dataIndex;" [attr.colspan]="displayedColumnsWithEdit.length" style="padding-right: 0;">
      <div class="edit-panel-wrapper"
        [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
        <div class="edit-panel">
          @for (col of displayedColumns; track col) {
            @if (col === 'eventName') {
              <div>
                <mat-form-field style="width: 80%;">
                  <mat-label>{{'general.event' | transloco}}</mat-label>
                  <input matInput inputrestriction="basic1"  type="text"
                    (keyup)="onFilter($event)"
                    value="{{element.eventName}}"
                    (change)="updateInput(col, index, $event.target['value'])"
                    (keydown.enter)="updateInput(col, index, $event.target['value'], true)"
                    [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="updateInput(col, index, $event.option.value)">
                      @for (option of eventsAllFiltered; track option) {
                        <mat-option [value]="option">
                          {{option}}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              }
              @if (col === 'condition') {
                <div>
                  <mat-form-field  style="width: 80%;">
                    <mat-label>{{'general.condition' | transloco}}</mat-label>
                    <mat-select (selectionChange)="dropdownOnSelectionChanged($event, element)" [(value)]="element.condition" placeholder="{{'general.selection' | transloco}}">
                      @for (option of options; track option) {
                        <mat-option [value]="option">{{option}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              @if (col === 'field') {
                <div>
                  <mat-form-field  style="width: 80%;">
                    <mat-label>{{'general.field' | transloco}}</mat-label>
                    <input matInput inputrestriction="basic1"  type="text"
                      (keyup)="onFilter($event)"
                      value="{{element.field}}"
                      (change)="updateInput(col, index, $event.target['value'])"
                      (keydown.enter)="updateInput(col, index, $event.target['value'], true)">
                    </mat-form-field>
                  </div>
                }
              }
            </div>

            <button mat-icon-button class="icon-edit-done" (mousedown)="collapseEditor();">
              <mat-icon
                [ngStyle]="{'color': 'var(--background-green)'}"
                style="font-size: 18px !important;"
                matTooltip="{{'general.save' | transloco}}">
                check
              </mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row  *matHeaderRowDef="displayedColumnsWithEdit"></tr>
      <tr mat-row (click)="onSelectedRow(row)" class="table-row" tabindex="1" *matRowDef="let row; columns: displayedColumnsWithEdit" [style.background]="highlightedRows.indexOf(row) > -1 ? 'var(--background-default2)' : ''"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedPanel']" class="edit-panel-row"></tr>
    </table>
